import { IUserAccountStore } from '../../index'
import { INotificationDelete } from '../../../../actions/notification/notifications'

export default function(store: IUserAccountStore, action: INotificationDelete) {
  const notification = store.notifications.items.find(
    not => String(not.id) === String(action.id),
  )

  return {
    ...store,
    notifications: {
      ...store.notifications,
      countNotRead:
        action.id === 'all'
          ? 0
          : notification && notification.readAt
          ? store.notifications.countNotRead
          : store.notifications.countNotRead === 0
          ? 0
          : store.notifications.countNotRead - 1,
      items:
        action.id === 'all'
          ? []
          : store.notifications.items.map(not => {
              if (not.id === action.id) {
                not.deletedAt = new Date()
              }
              return not
            }),
    },
  }
}
